module.exports = __webpack_public_path__ + "media/f01.d30fe8e8.mp4";